import { INFO_STEP, TOTAL_NUM_STEPS } from "../helpers/constants";
import { usePathname } from "../hooks/usePathname";

export const StepsBadge = () => {
	const pathname = usePathname();

	return (
		<div
			role="presentation"
			className="tw:mb-2 tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:rounded-full tw:bg-[#FDEEF2] tw:px-4 tw:py-2"
		>
			<span className="tw:text-xs tw:leading-4 tw:font-semibold tw:text-[#E1255B]">
				{`Step ${
					pathname === INFO_STEP ? 1 : TOTAL_NUM_STEPS
				} of ${TOTAL_NUM_STEPS}`}
			</span>
		</div>
	);
};
